// extracted by mini-css-extract-plugin
export default {"recos":"C3-z","productCardOverride":"D3-z","rowHasBadge":"E3-z"};